module.exports = __webpack_public_path__ + "images/emoji/atm.7da90689d91b0878dd9f.png";